import React from "react";
import {CardHeader} from "reactstrap";
import PropTypes from "prop-types";

export default class PrimaryCardHeader extends React.Component{

    render() {
        let {content, onClick, style} = this.props
        if(!onClick){
            onClick = () => {}
        }
        if(!style){
            style = {}
        }
        style = {...style, verticalAlign:'center'}
        return (
            <CardHeader
                className="bg-header align-items-center align-content-center justify-content-center"
                style={style}
                onClick={(e)=>{
                    onClick(e)
                }}>
                {content}
            </CardHeader>
        );
    }

}

PrimaryCardHeader.propTypes={
    content: PropTypes.any,
    onClick: PropTypes.func,
    style: PropTypes.any,
}
